import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// users
import user1 from "../../../assets/images/Logo.png";
import { getBrandColor } from "../../../theme";

const ProfileMenu = props => {
  const history = useHistory();
  // Uncontrolled dropdown handles its own open/close state

  const [username, setusername] = useState("Admin");

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  const handleLogout = () => {
    const brand = getBrandColor();
    Swal.fire({
      // title: props.t("Are you sure?"),
      title: props.t("Are you sure you want to Logout?"),
      // icon: "warning",
      customClass: {
        popup: "my-swal-popup",
      },
      showCancelButton: true,
      confirmButtonColor: brand,
      cancelButtonColor: "#d33",
      confirmButtonText: props.t("Yes, Logout it!"),
      cancelButtonText: props.t("Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        history.push("/logout");
      }
    });
  };

  return (
    <React.Fragment>
      <UncontrolledDropdown className="d-inline-block" inNavbar>
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
          type="button"
        >

          <span className="d-xl-inline-block me-1" style={{ padding: '5px 11px', background: 'var(--brand)', borderRadius: '100%', color: 'white', fontSize: '13px' }}>A</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">

          <Link to="/admin/profile" className="dropdown-item">
            <i className="bx bx-user font-size-16 me-1 align-middle" />
            <span>{props.t("Profile")}</span>
          </Link>
          <div className="dropdown-divider" />
          <button onClick={handleLogout} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </button>
        </DropdownMenu>
      </UncontrolledDropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
